export default "__VITE_ASSET__Ct81WW6a__"